import { allTrackers } from "app/services/track/track";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";

export type HomePageTrackingEntity = {
    trackSearch: (searchType: string, itemType: string, value: string) => void;
    trackChangeDefaultProject: () => void;
    trackFilterApply: (filter: string) => void;
    trackProjectSearch: (value: string, num: number) => void;
    trackRemoveDefaultProject: () => void;
    trackCreateProject: (numOfProject: number) => void;
    trackSubscribe: (location: "table" | "menu") => void;
    trackSubscriptionSettingsIcon: () => void;
    trackContextMenu: () => void;
    trackConnectGa: () => void;
    trackProjectSettings: () => void;
    trackClickAlerts: () => void;
};

const createHomeTracking = (track: TrackType): HomePageTrackingEntity => ({
    trackSearch(searchType: string, itemType: string, value: string) {
        track("Search Bar", "click", `${searchType}/${itemType}/${value}`);
    },
    trackChangeDefaultProject() {
        track("Button", "click", `Select Project as default homepage/replace`);
    },
    trackRemoveDefaultProject() {
        track("Button", "click", `remove project from default homepage`);
    },
    trackFilterApply(filterName: string) {
        track("Button", "click", `filter projects/${filterName}`);
    },
    trackProjectSearch(value: string, num: number) {
        track("Search Bar", "click", `${value}/${num}`);
    },
    trackCreateProject(numOfProject: number) {
        track("Button", "click", `Create new project/projects overview page/${numOfProject}`);
    },
    trackSubscribe(location: "table" | "menu") {
        track("Button", "click", `subscribe/alerts subscription/${location}`);
    },
    trackSubscriptionSettingsIcon() {
        track("Button", "click", `subscription settings`);
    },
    trackContextMenu() {
        track("Button", "click", `open options menu/projects table options`);
    },
    trackConnectGa() {
        track("Button", "click", `connect to ga/projects table options`);
    },
    trackProjectSettings() {
        track("Button", "click", `project settings/projects table options`);
    },
    trackClickAlerts() {
        track("Button", "click", `alerts/projects table options`);
    },
});

export default createHomeTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
